export default "__VITE_ASSET__UeGVvbA5__"